import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";

import { NofeshService } from "../../nofesh.service";
import { INofesh } from "../../model/nofesh";
import { INofeshSelected, NofeshSelected } from "../../../shared/interfaces/Inofesh-selected.interface";
import { ENofeshType } from "../../../shared/enums/enofesh-type.enum";
import {MatTooltipModule} from '@angular/material/tooltip';
import { INofshonNirshamim } from "app/nofshonim-chul/model/nofshon-nirshamim";
import { filter } from "rxjs-compat/operator/filter";
import { INirsham } from "app/nofesh/model/nirsham";
import { NofshonimService } from "app/nofshonim-chul/nofshonim.service";
import { Subscription } from "rxjs";
import { UserMessagesService } from "app/shared/user-messages/user-messages.service";
import { MatDialog } from "@angular/material";
import { ConfirmDialogComponent } from "app/shared/dialog/confirm-dialog/confirm-dialog.component";
import { ConfirmService } from "app/shared/dialog/confirm.service";




@Component({
    moduleId: module.id,
    templateUrl: 'header-panel.component.html',
    selector: 'header-panel'
})
export class HeaderComponent implements OnInit, OnDestroy 
{
    @Input() userSelectedNofesh: INofeshSelected;
    @Input() selectedNofesh: INofesh;
    @Output() cancelReservationByUser: EventEmitter<void> = new EventEmitter();

    updateReservationUrl: string = "";
    uploadFilesUrl: string = "";
    nofeshTypes = {
        nofeshPnim: ENofeshType.NofeshPnim,
        meurganimPnim: ENofeshType.MeurganimPnim,
        nofeshChul: ENofeshType.NofeshChul, // Nofshon
        meurganimChul: ENofeshType.MeurganimChul, // Nofesh
        mishpachotChul: ENofeshType.MishpachotChul
    };

    //following 2 lines added in order to check if the user has reservation that wasn't ended
    nirshamim_chul_mishpachot: INofshonNirshamim
    isUserEndedReservationNofshon: boolean = true;

    private _homePageTimerSubscription: Subscription;
    private _homePageTimerTimeoutSubscription: Subscription;
    userSelectedNofeshSubscription: Subscription;
    cancelReservationSubmitted: boolean = false;

    constructor(
        private _nofeshService: NofeshService, 
        private _nofshonimService: NofshonimService,
        private _messagesService: UserMessagesService,
        private _confirmDialog: MatDialog,
        private _confirmDialogService: ConfirmService,
        private _router: Router
    ) { }

    ngOnInit() 
    {

        console.log("Header - on init selected nofesh", this.selectedNofesh);
        console.log("Header - on init user selected nofesh", this.userSelectedNofesh);


        if(!this.userSelectedNofesh.isNofshon)
        {
            //
            // TODO: when not nofshon, use isReservationCompleted property of INofeshSelected instead of getting nirshamim
            //
            console.log("TODO: nofesh - use isReservationCompleted instead of this block");


            this._nofeshService.getNofeshNirshamimHeaderPanel(this.userSelectedNofesh.id_nofesh,this.userSelectedNofesh.isNofshon)
                .subscribe((nirshamim: INirsham[]) => {
                    let nirshamimM = nirshamim;
                    if (nirshamimM != null && nirshamimM.length > 0) 
                    {
                        if(nirshamimM[0].ms_zehut == 0)
                        {
                            this.isUserEndedReservationNofshon = false;
                        }
                    }
                });
        }
            
        if (this.userSelectedNofesh.id_nofesh > 0 && this.userSelectedNofesh.id_reservation > 0) 
        {
            switch(this.userSelectedNofesh.nofesh_type)
            {
                case ENofeshType.NofeshPnim:
                case ENofeshType.MeurganimPnim:
                    this.updateReservationUrl = '/nofesh-pnim/pirtey-nofshim';
                    this.uploadFilesUrl = '/nofesh-pnim/uploads';
                    this.nirshamim_chul_mishpachot = JSON.parse(sessionStorage.getItem("nofshon-nirshamim")) as INofshonNirshamim
                    break;
                case ENofeshType.NofeshChul:

                    this.updateReservationUrl = '/nofshonim-chul/pirtey-nofshim';
                    this.uploadFilesUrl = '/nofshonim-chul/uploads';
                    this.nirshamim_chul_mishpachot = JSON.parse(sessionStorage.getItem("nofshon-nirshamim")) as INofshonNirshamim
                    break;
                case ENofeshType.MeurganimChul:
                    this.updateReservationUrl = '/nofesh/order-nofesh/';
                    this.uploadFilesUrl = '/nofesh/nofesh-uploads';                    
                    break;
                case ENofeshType.MishpachotChul:
                    this.updateReservationUrl = '/mishpachot-chul/pirtey-nofshim';
                    this.uploadFilesUrl = '/mishpachot-chul/uploads';
                    this.nirshamim_chul_mishpachot = JSON.parse(sessionStorage.getItem("nofshon-nirshamim")) as INofshonNirshamim
                    break;
            }
        }

        if(this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh))
        {
            if(this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted)
            {
                this._nofshonReservationTimerHandler();
            }
        }

        console.log("Header - on init finish");
        console.log("");
    }

    private _nofshonReservationTimerHandler(): void
    {
        this._homePageTimerSubscription = this._nofshonimService.homePageHasTimer$.subscribe((hasTimer: boolean) => {
            console.log("Header - notified about homepage timer. Has timer?", hasTimer);

            if(hasTimer)
            {
                this._homePageTimerTimeoutSubscription = this._nofshonimService.homePageTimerTimeout$.subscribe((timeout: boolean) => {
                    console.log("Header - timer timeout subscription notified. Is timeout?", timeout);
                    if(timeout)
                    {
                        console.log("Header - notified about homepage timer timeout, reset selected nofesh");
                        this.selectedNofesh = null;
                    }
                });
            }
        });
    }

    setEditMode(): boolean
    {
        if(!this.userSelectedNofesh.isEditMode)
        {
            this.userSelectedNofesh.isEditMode = true;
            sessionStorage.setItem("userSelectedNofesh", JSON.stringify(this.userSelectedNofesh));
        }
        return true;
    }

    showConfirmCancelDialog()
    {
        const dialogRef = this._confirmDialog.open(ConfirmDialogComponent, {
            width: "600px",
            data: { 
                title: "ביטול הזמנה",
                content: [
                    "האם לבטל את ההזמנה?",
                    "",
                    "עלות ביטול הזמנה בעמותה - 80 ₪ לנוסע.",
                    "לא ייגבה תשלום על ביטול נופש בהמתנה."
                ],
                confirmButtonText: "כן, אני רוצה לבטל",
                declineButtonText: "סגור"
            },
            hasBackdrop: true,
            disableClose: true,
            restoreFocus: true,
            closeOnNavigation: true,
        });

        const dialogSubscription = this._confirmDialogService.confirm$.subscribe(() => {
            dialogRef.close();
            dialogSubscription.unsubscribe();

            console.log("Header - cancel reservation");

            const cancelReservationFailureSubscription = this._nofeshService.cancelReservationFailure$.subscribe(() => {
                console.log("Header - notified failed cancel");
                this.cancelReservationSubmitted = false;
                cancelReservationFailureSubscription.unsubscribe();
            }, () => cancelReservationFailureSubscription.unsubscribe());

            this.cancelReservationSubmitted = true;
            this.cancelReservationByUser.emit();
        });

    }

    navigate(url: string, param: number | object): void
    {
        if(!url)
        {
            console.error("Navigation url is not specified");
            return;
        }

        if(typeof param === "object")
        {
            this._router.navigate([url], { queryParams: param });
        }
        else
        {
            this._router.navigate([url, param]);
        }
    }

    ngOnDestroy(): void 
    {
        if(this._homePageTimerSubscription)
        {
            this._homePageTimerSubscription.unsubscribe();
        }

        if(this._homePageTimerTimeoutSubscription)
        {
            this._homePageTimerTimeoutSubscription.unsubscribe();
        }
    }
}
